import { Box, Stack } from "@mui/material";
import React, { useEffect } from "react";
import { Color, FontStyle, JobDisplays } from "../../../constants";
import {
  DownloadTemplateWrapper,
  jobButtonStyle,
  JobDownloads,
} from "../../../utils/jobUtils";
import {
  ResourceBody,
  ResourceContainer,
  ResourceHeader,
} from "../ResourcePanel";

const resource1 = [
  ["b", "How to craft effective bullet points for your resume"],
  ["x-div", ""],
  // ["i", "By ex-recruiters @ Meta, Google, and more!"],
  [
    "li-1",
    "Be specific (i.e. use the most representative example of your work)",
  ],
  [
    "li-2",
    "Include data (i.e. how much time, money, or resources were saved? Was there an OKR/Goal attached?)",
  ],
  [
    "li-3",
    "Include stakeholders (i.e. who was involved, who was reported to and impacted)",
  ],
  [
    "li-4",
    "State your impact and scope (i.e. how many people or systems did your project touch)",
  ],
  [
    "li-5",
    "Include outcomes (i.e. what lasting impact did you have, or are having in your role?)",
  ],
  [
    "li-6",
    "Bonus: Include recognition/awards/qualifiers (i.e. were you the top code generator or bug finder etc)",
  ],
  ["x-div", ""],
];
const resource2 = [
  ["b", "Frameworks for Bullet Points"],
  ["x-div", ""],
  [
    "li",
    "Managed a team of [number] employees to complete [project/task] within [timeline/deadline].",
  ],
  [
    "li",
    "Implemented [strategy/program] that resulted in [percentage/number] increase in [metric]. ",
  ],
  [
    "li",
    "Streamlined [process/system] to improve efficiency and reduce [cost/time].",
  ],
  ["li", "P.S. Don't forget to quantify your experience!"],
  ["x-div", ""],
];
const resource3 = [
  ["b", "Sample Resume Bullets"],
  ["x-div", ""],
  // [
  //   "i",
  //   "Written by ex-recruiters with decades of experience @ Fortune 500 companies",
  // ],
  [
    "li",
    "Database Creation: Utilized SQL to monitor 10 Microsoft Access databases critical to merchandising efforts. Databases utilized company wide by 5 teams and over 50 engineers. Goal to improve efficiency by 2x and exceeded goal, saving company 5 million in revenue. ",
  ],
  [
    "li",
    "As Co-Chair of Hackathon Committee, I drove event coordination for an annual University Hackathon, hosting over 500+ students. Responsible for coordination with vendors, university administration, and participant communications. Delivered a highly successful event as one of 5 members of Hackathon Committee.",
  ],
];

const resourceDescription = {
  showIdx: 3,
  lastElementShown: 96,
  list: [...resource1, ...resource2, ...resource3],
};

const ResumeResource = ({
  job,
  fullHeight = false,
  showDescriptionOverlay = false,
}) => {
  const [showMore, setShowMore] = React.useState(false);
  // if (!job) return null;
  return (
    <ResourceContainer
      fullHeight={fullHeight}
      showDescriptionOverlay={showDescriptionOverlay}>
      <ResourceHeader
        title="Tips, Templates, and Resources for Crafting an Effective Resume"
        subtitle="By Former Meta, Google, and Uber Recruiters at Fetti"
      />
      <ResourceBody data={resourceDescription} />
      {/* Bottom row with url + apply button */}
      <DownloadTemplateWrapper href={JobDownloads.resumeTemplate}>
        <Box sx={{ ...jobButtonStyle, width: "100%", maxWidth: "100%" }}>
          Download Our Free Resume Template
        </Box>
      </DownloadTemplateWrapper>
    </ResourceContainer>
  );
};

export default ResumeResource;
